import { atomWithStorage } from 'jotai/utils';

export interface Facility {
  /** Always `l_site_group.site_group_code` — this is what axios sends as `X-Site-Group`. Never the description. */
  id: string;
  /** Display-only `l_site_group.description` from the API. Must not be used as `X-Site-Group`. */
  name: string;
}

export const selectedFacilityAtom = atomWithStorage<Facility | null>('selected_facility', null);
